<template>
  <Table class='user-table'
    :data="users"
    :totalRows='count'
    :pagination='{ current: page }'
    :onChange='handleTableChange'
    :loading='loading'>
    <a-table-column :width='50'>
      <span slot="title">
        <img src="../../assets/search.png" class='search-icon' @click='showSearch'>
      </span>
      <template slot-scope="name, record">
        <img alt="Warning icon" class='warning-icon' src="../../assets/warning-icon.png" v-if='!record.firstName || !record.lastName'>
      </template>
    </a-table-column>
    <a-table-column dataIndex="lastName" key="lastName">
      <span slot="title">
        <SearchInput v-if="showSearchInput" @searched='search' @hideSearchInput='hideSearch' />
        <span v-if='!showSearchInput'>Name</span>
      </span>
      <template slot-scope="name, record">
        <div class='clickable-cell' @click="openEditFormWithSubscription(record)">
          <a>{{record.firstName}} {{record.lastName}}</a>
        </div>
      </template>
    </a-table-column>
    <a-table-column title='Email' dataIndex='email' key='email' :sorter='true'>
      <template slot-scope="email">
        <a :href='`mailto:${email}`'>{{ email }}</a>
      </template>
    </a-table-column>
    <a-table-column title='Company' dataIndex='companyName' key='companyName'>
      <template slot-scope="companyName">{{ companyName }}<span v-if='!companyName'>--</span></template>
    </a-table-column>
    <a-table-column title='Subscription' dataIndex="email" key="subscription">
      <template slot-scope="subscriptionId, record" v-if='record.plan'>
        {{ generateName()(record) }}
      </template>
    </a-table-column>
    <a-table-column title='Plan' dataIndex='plan' key='plan' :sorter='true'>
      <template slot-scope="_name, record">
        <PlanDetails :name="record.plan == 'customer' ? 'Customer' : record.plan" :expiresAt='record.expiresAt' v-if='record.plan'></PlanDetails>
      </template>
    </a-table-column>
    <a-table-column title='Expiry date' dataIndex='expiresAt' key='expiresAt' :sorter='true' :sortDirections='["descend", "ascend"]'>
      <template slot-scope="expiresAt" v-if='expiresAt'>{{ prettyDate(expiresAt) }}</template>
    </a-table-column>
    <a-table-column :width='43' dataIndex='id' key='id' fixed='right'>
      <template slot-scope='_name, record'>
        <a-popover trigger="click">
          <template slot="content">
            <a @click='loginAsUser(record.id)'>Login as {{ record.firstName || "user" }}</a>
          </template>
          <span class='clickable-cell'>
            <MoreDotsIcon class="more-dots" />
          </span>
        </a-popover>
      </template>
    </a-table-column>
  </Table>
</template>

<script>
  import Table from '@/components/Table'
  import PlanDetails from '@/components/PlanDetails'
  import SearchInput from '@/components/SearchInput'
  import MoreDotsIcon from '../../../public/more-dots-icon.svg'
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
  import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
  import dayjs from 'dayjs'

  export default  {
    name: 'EditUserForm',
    components: {
      Table,
      PlanDetails,
      SearchInput,
      MoreDotsIcon
    },
    data() {
      return {
        showSearchInput: false,
      }
    },
    computed: {
      ...mapState('users', ['users', 'count', 'page', 'loading', 'order', 'asc']),
    },
    methods: {
      ...mapActions('users', ['fetchPage']),
      ...mapActions('loginAsUser', ['getToken']),
      ...mapMutations('editUserForm', { openEditForm: 'open'}),
      ...mapMutations('newUserForm', {addSubscriptions: 'fetchedSubscriptions'}),
      ...mapGetters('subscriptions', ['generateName']),
      openEditFormWithSubscription(user) {
        const { country, city, companyName, subscription: id} = user
        const subscriptions = [{id, companyName, country, city }]
        if(id) this.addSubscriptions({ subscriptions })
        if(!user.subscription) user.subscription = undefined // change null to undefined so the placeholder displays in the subscription autocomplete
        this.openEditForm(user)
      },
      prettyDate(date) {
        return dayjs(date).format('D MMMM, YYYY')
      },
      handleTableChange(pagination, filters, sorter) {
        this.fetchPage({
          page: pagination.current,
          order: sorter.field,
          asc: sorter.order === 'ascend',
        })
      },
      showSearch() {
        this.showSearchInput = true
      },
      hideSearch() {
        this.showSearchInput = false
      },
      search(searchTerm) {
        this.fetchPage({
          search: searchTerm,
        })
      },
      loginAsUser(id) {
        this.getToken(id)
      },
    },
    mounted() {
      this.fetchPage();
    },
  }
</script>

<style lang='stylus'>

  .user-table {
    margin-top: $spacingLg;
  }

  .warning-icon {
    width: 20px;
    height: 20px;
    vertical-align: sub;
  }

  .search-icon {
    width: 20px;
    cursor: pointer;
  }

  .more-dots {
    cursor: pointer;

    &:hover {
      g {
        fill: $secondaryBlue;
      }
    }
  }

  .ant-table-body {
    overflow: scroll;
  }

  .user-table .ant-table-tbody > tr > td:nth-of-type(2),  {
    padding: 0;

    div.clickable-cell {
      padding: 20px;

      &:hover {
        cursor: pointer;
        a { color: $secondaryBlue; }
      }
    }
  }

  .user-table .ant-table-thead > tr > th:first-of-type, .user-table .ant-table-tbody > tr > td:first-of-type {
    padding-right: 0px;
    border-right: 0px;
  }

  .ant-table-body-outer .ant-table-row td {
    padding: 0;

    span.clickable-cell {
      display: inline-block;
      height: 62px;
      width: 100%;
      text-align: center;
      padding-top: 50%;

      &:hover {
        cursor: pointer;

        g {
          fill: $secondaryBlue;
        }
      }
    }
  }

</style>